var render = function (_h,_vm) {var _c=_vm._c;return _c('CardLayout',_vm._g(_vm._b({staticClass:"columns-layout",class:_vm.data.staticClass},'CardLayout',_vm.data.attrs,false),_vm.listeners),[_c('template',{slot:"title"},[_vm._t("title")],2),_c('template',{slot:"solo"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }